/*
 * The Checkout component is mounted independently via checkout/show.html.erb
 * using the react_mount_controller.js. Since it is not part of the MainApp, it
 * does not include MainApp router context. As a result, route hooks fail because
 * the router context is missing. We use regex-based pattern matching for the post
 * details page route instead.
 */
export const isPostDetailsPage = (): boolean => {
  const { pathname } = window.location;
  return /^\/c\/[^/]+\/[^/]+\/?$/.test(pathname);
};
